export function Footer() {
  return (
    <footer className="border-t bg-background py-4">
      <div className="text-center text-sm text-muted-foreground">
        © {new Date().getFullYear()} SKG Metal Yönetim. Powered by{" "}
        <a
          className="font-medium underline underline-offset-4"
          href="https://b-303.com"
          rel="noopener noreferrer"
          target="_blank"
        >
          B-303
        </a>.
      </div>
    </footer>
  )
}
